// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles_logo__Z2hiV","logoText":"styles_logoText__p5Z0S"};